module.exports = __webpack_public_path__ + "img/qr.7991b1fd.png";